import { render } from "./ZuschussStandardPosition.pug?vue&type=template&id=19182602&lang=pug"
import script from "./ZuschussStandardPosition.js?vue&type=script&lang=js"
export * from "./ZuschussStandardPosition.js?vue&type=script&lang=js"

import "./ZuschussStandardPosition.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__